const getters = {
	// Регистрация. Получить код
	registrationGetters: (state: { registrationState: object }) =>
		state.registrationState,

	// Проверяем код подтверждения
	confirmationCodeGetters: (state: { confirmationCodeState: object }) =>
		state.confirmationCodeState,

	// Увеличить количество попыток (attempts)
	increaseAttemptsGetters: (state: { increaseAttemptsState: object }) =>
		state.increaseAttemptsState,

	// Номер телефона
	phoneNumberGetters: (state: { phoneNumberState: object }) =>
		state.phoneNumberState,
};
export default getters;
